import {Injectable} from '@angular/core';
import {UntypedFormArray, UntypedFormGroup, ValidationErrors} from '@angular/forms';
import moment from 'moment';
import {isNil, isUndefined, cloneDeep} from 'lodash';
import { TradeSimulation } from '../models/TradeSimulation';
import { InstrumentItem } from '../models/InstrumentItem';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {
    constructor() {
    }

    overlayLoadingTemplate = '<span class="font-weight-bold">LOADING, Please wait...</span>';

    overlayNoRowsTemplate = '<span class="font-weight-bold">NO ROW</span>';

    roundNumberTo2DecimalPlaces(value: number): number {
        return (Math.round(value * 100) / 100);
    }

    getFormValidationErrors(formGroup: UntypedFormGroup) {
        Object.keys(formGroup.controls).forEach(key => {

            if (formGroup.get(key) instanceof UntypedFormArray) {
                const ary = <UntypedFormArray>formGroup.get(key);

                Object.keys(ary.controls).forEach(key2 => {
                    const fg = ary.controls[key2];
                    this.getFormValidationErrors(fg);
                });
            } else {
                const controlErrors: ValidationErrors = formGroup.get(key).errors;
                if (controlErrors != null) {
                    Object.keys(controlErrors).forEach(keyError => {
                        console.log('Key control: ' + key + ', keyError: ' + keyError + ', err value: ', controlErrors[keyError]);
                    });
                }
            }
        });
    }

    trimString(str: string): string {
        return str && str.trim() || null;
    }

    commaGroupNumber(num) {
        const str = num.toString().split('.');
        if (str[0].length >= 4) {
            str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
        }
        if (str[1] && str[1].length >= 4) {
            str[1] = str[1].replace(/(\d{3})/g, '$1 ');
        }
        return str.join('.');
    }

    isValidDateByDateFormat(dateValue: string, dateFormat: string) {
        return moment(dateValue, dateFormat, true).isValid();
    }

    /**
     * Remove units (k, M, B) and adjust the numerical values accordingly.
     *
     * @param {string} s
     * @returns {string}
     * @memberof UtilityService
     */
    csvFormatter(s: any): string {
        const type = typeof(s);
        if (type !== 'string') {
            return s;
        }
        const val = s.replace(/^([-+0-9,.]+)\s(k|M|B)\b/, (str: string, numStr: string, unit: string) => {
            const noComma = numStr.replace(/,/, '');
            const num = Number(noComma);
            switch(unit) {
                case 'k':
                    return `${num*1000}`;
                case 'M':
                    return `${num*1000000}`;
                case 'B':
                    return `${num*1000000000}`;
                /*
                default:
                    console.log(`Unknown unit ${unit} for ${s}`);
                */
            }
            return s;
        });
        if (val) {
            return val;
        } else {
            return s;
        }
    }

    private _twoLegs = ['IRS', 'CCS'];

    simuTxCallback(simulation: TradeSimulation): TradeSimulation {
        const simu: TradeSimulation = cloneDeep(simulation);
        if (simu.instruments) {
            for (const instrument of simu.instruments) {
                if (this._twoLegs.indexOf(instrument.instrType) !== -1) {
                    instrument.leg1Notional = instrument.leg1IrsNotional;
                    instrument.leg2Notional = instrument.leg2IrsNotional;
                    delete (instrument.leg1IrsNotional);
                    delete (instrument.leg2IrsNotional);
                }
            }
        }
        return simu;
    }

    simuRxCallback(list: InstrumentItem[]): InstrumentItem[] {
        const instruments: InstrumentItem[] = cloneDeep(list);
        if (instruments) {
            for (const instrument of instruments) {
                if (this._twoLegs.indexOf(instrument.instrType) !== -1) {
                    instrument.leg1IrsNotional = instrument.leg1Notional
                    instrument.leg2IrsNotional = instrument.leg2Notional;
                }

            }
        }
        return instruments;
    }

    compareInstruments(a: any, b: any): number {
        if (isNil(a)) {
            return -1;
        } else if (isNil(b)) {
            return 1;
        } else {
            let t1 = a['instrType'];
            let t2 = b['instrType'];
            if (isUndefined(t1)) {
                t1 = '';
            }
            if (isUndefined(t2)) {
                t2 = '';
            }
            const compared = t1.localeCompare(t2);
            if (compared) {
                return compared;
            }
            let id1 = a['leg1Id'];
            let id2 = b['leg1Id'];
            if (isUndefined(id1)) {
                id1 = '';
            }
            if (isUndefined(id2)) {
                id2 = '';
            }
            return id1.localeCompare(id2);
        }
    }
}
